import { FC } from "react";

type TChatGroupMembersDropdownProps = {
  title: string;
  values: string[];
}

const ChatGroupMembersDropdown: FC<TChatGroupMembersDropdownProps> = ({ title, values }) => {
  return (
    <div className="absolute top-full -right-3 bg-white rounded-lg flex flex-col p-3 mt-3 w-48 shadow-lg border border-black/10 text-center z-popup">
      <h4 className="font-semibold text-accent-blue-dark mb-4">{title}</h4>
      <ul className="flex flex-col gap-2 text-xs max-h-[calc(100vh-290px)] overflow-auto">
        {values.map((value, index) => (
          <li key={index}>{value}</li>
        ))}
      </ul>
    </div>
  );
}
export default ChatGroupMembersDropdown;